<script>
import MainContainer from '@/components/container/MainContainer.vue';
import LeftPanel from '@/components/container/LeftPanel.vue';
import RightContainer from '@/components/container/RightContainer.vue';

import ButtonReturn from '@/components/left-panel/unique-buttons/ButtonReturn.vue';

import ImagesUploadAnalyticsList from '@/components/page-system-analytics/ImagesUploadAnalyticsList.vue';
import ImagesUploadAnalyticsDateRange from '@/components/page-system-analytics/ImagesUploadAnalyticsDateRange.vue';

import { promiseAll, calculatePromise } from '@/api/default.js';
import constants from '@/constants';

export default {
    components: {
        MainContainer,
        LeftPanel,
        RightContainer,
        ButtonReturn,
        ImagesUploadAnalyticsList,
        ImagesUploadAnalyticsDateRange,
    },
    data() {
        return {
            today: new Date(),
        };
    },
    async mounted() {
        this.$store.commit('IS_LOAD', true);

        // Set default date range (last 7 days)
        const endDate = new Date();
        const startDate = new Date();
        startDate.setDate(endDate.getDate() - 7);

        const startDateStr = this.formatDateForApi(startDate);
        const endDateStr = this.formatDateForApi(endDate);

        await this.$store.dispatch('setSystemAnalyticsDateRange', {
            startDate: startDateStr,
            endDate: endDateStr,
        });

        this.$store.commit('IS_LOAD', false);
    },
    methods: {
        formatDateForApi(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
    },
};
</script>

<template>
    <MainContainer>
        <LeftPanel>
            <ButtonReturn />
        </LeftPanel>
        <RightContainer>
            <div class="right_container_header">
                <h1>System Analytics</h1>
            </div>
            <hr />

            <div class="right_container_data">
                <ImagesUploadAnalyticsDateRange />
                <hr />
                <ImagesUploadAnalyticsList />
            </div>
        </RightContainer>
    </MainContainer>
</template>

<style scoped>
.right_container_header {
    padding: 20px;
    background: var(--background);
    color: var(--background-text);
}

.right_container_header h1 {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
}

.right_container_data {
    padding: 20px;
}
</style>
